/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetBlockadeMonthTeamDto
 */
export interface GetBlockadeMonthTeamDto {
    /**
     * 
     * @type {string}
     * @memberof GetBlockadeMonthTeamDto
     */
    id: string;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetBlockadeMonthTeamDto
     */
    team: GetTeamDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetBlockadeMonthTeamDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetBlockadeMonthTeamDto interface.
 */
export function instanceOfGetBlockadeMonthTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetBlockadeMonthTeamDtoFromJSON(json: any): GetBlockadeMonthTeamDto {
    return GetBlockadeMonthTeamDtoFromJSONTyped(json, false);
}

export function GetBlockadeMonthTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBlockadeMonthTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'team': GetTeamDtoFromJSON(json['team']),
        'active': json['active'],
    };
}

export function GetBlockadeMonthTeamDtoToJSON(value?: GetBlockadeMonthTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'team': GetTeamDtoToJSON(value.team),
        'active': value.active,
    };
}

